import React, { useRef, useEffect, useState } from "react";
import { Group, Line, Circle, Rect } from "react-konva";

const GRID_SIZE = 25;
const STROKE_WIDTH = 8;
const ANCHOR_RADIUS = 10;


const Wall = ({ shapeProps, isSelected, onSelect, onChange, isFreeSize = false }) => {
  const groupRef = useRef();

  // shapeProps: { id, x, y, x2, y2, strokeWidth, rotation }
  const { id, x, y, x2, y2, strokeWidth = STROKE_WIDTH, rotation = 0 } = shapeProps;

  const [xMin, setXMin] = useState(Math.min(x, x2));
  const [yMin, setYMin] = useState(Math.min(y, y2));
  const [xMax, setXMax] = useState(Math.max(x, x2));
  const [yMax, setYMax] = useState(Math.max(y, y2));
  const snapToGrid = (value) => isFreeSize ? value : Math.round(value / GRID_SIZE) * GRID_SIZE;

  // 両端アンカーのドラッグハンドラ
  const handleAnchorDrag = (anchor, e) => {
    const newPos = {
      x: snapToGrid(e.target.x()),
      y: snapToGrid(e.target.y()),
    };
    let { x, y, x2, y2 } = shapeProps;

    // ドラッグ量を計算
    const dx = Math.abs(newPos.x - (anchor === "start" ? x2 : x));
    const dy = Math.abs(newPos.y - (anchor === "start" ? y2 : y));

    if (dx > dy) {
      // 水平線にする（yは固定、xだけ動かす）
      if (anchor === "start") {
        x = newPos.x;
        y = y2; // yを固定
      } else {
        x2 = newPos.x;
        y2 = y; // y2を固定
      }
    } else {
      // 垂直線にする（xは固定、yだけ動かす）
      if (anchor === "start") {
        x = x2; // xを固定
        y = newPos.y;
      } else {
        x2 = x; // x2を固定
        y2 = newPos.y;
      }
    }
    onChange({ ...shapeProps, x, y, x2, y2 });
  };

  return (
    <Group
      ref={groupRef}
      x={0}
      y={0}
      onClick={onSelect}
      onTap={onSelect}
      rotation={rotation}
    >
      <Rect
        x={xMin}
        y={yMin}
        width={xMax - xMin}
        height={yMax - yMin}
        stroke={isSelected ? "black" : "gray"}
        strokeWidth={strokeWidth}
        rotation={rotation}
        hitStrokeWidth={24}
        onClick={onSelect}
        onTap={onSelect}
        draggable
        dragBoundFunc={(pos) => ({
          x: snapToGrid(pos.x),
          y: snapToGrid(pos.y),
        })}
        onDragEnd={(e) => {
          let { x, y, x2, y2 } = shapeProps;
          x = e.target.x();
          y = e.target.y();
          x2 = x + e.target.width();
          y2 = y + e.target.height();
          onChange({ ...shapeProps, x, y, x2, y2 });
          setXMin(Math.min(x, x2));
          setYMin(Math.min(y, y2));
          setXMax(Math.max(x, x2));
          setYMax(Math.max(y, y2));
        }}  
      />
      {isSelected && (
        <>
          {/* 始点アンカー */}
          <Circle
            key={`start-anchor-${xMin}-${yMin}`}
            x={xMin}
            y={yMin}
            radius={ANCHOR_RADIUS}
            fill="black"
            draggable
            onDragMove={(e) => handleAnchorDrag("start", e)}
            onDragEnd={(e) => {
                let { x, y, x2, y2 } = shapeProps;
                setXMin(Math.min(x, x2));
                setYMin(Math.min(y, y2));
                setXMax(Math.max(x, x2));
                setYMax(Math.max(y, y2));      
            }}
            dragBoundFunc={(pos) => ({
              x: snapToGrid(pos.x),
              y: snapToGrid(pos.y),
            })}
            onClick={onSelect}
            onTap={onSelect}
            opacity={0.3}
          />
          {/* 終点アンカー */}
          <Circle
            key={`end-anchor-${xMax}-${yMax}`}
            x={xMax}
            y={yMax}
            radius={ANCHOR_RADIUS}
            fill="black"
            draggable
            onDragMove={(e) => handleAnchorDrag("end", e)}
            onDragEnd={(e) => {
                let { x, y, x2, y2 } = shapeProps;
                setXMin(Math.min(x, x2));
                setYMin(Math.min(y, y2));
                setXMax(Math.max(x, x2));
                setYMax(Math.max(y, y2));      
            }}
            dragBoundFunc={(pos) => ({
              x: snapToGrid(pos.x),
              y: snapToGrid(pos.y),
            })}
            onClick={onSelect}
            onTap={onSelect}
            opacity={0.3}
          />
        </>
      )}
    </Group>
  );
};

export default Wall; 